import React from 'react';
import style from './style.module.css';
import { Icon, InputNumber } from 'antd';
import { useSelector } from 'react-redux';

const checked = (day) => {
  if (day && day.timeSpent === 8) {
    return true;
  }
};

const showHoliday = (day, data, holidayDates) => {
  if (day === 'sat' || day === 'sun') {
    return style.holiday;
  }
  if (holidayDates.includes(data[day].date)) {
    return style.holiday;
  }
  return null;
};

const daysArray = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

const Row = ({ data, handleInputChange }) => {
  const holidayDates = useSelector((state) => state.holidayInfo).map(
    (entry) => entry.date
  );
  return data.type === 'input' ? (
    <div className={`${style.row} ${data.group === 'other' && style.other}`}>
      <div className={style.rowName}>{data.name}</div>
      {daysArray.map((day) => (
        <div key={day} className={showHoliday(day, data, holidayDates)}>
          {data.group === 'other' ? (
            checked(data[day]) === true ? (
              <div className={style.rowCheckbox}>
                <Icon
                  type="check-circle"
                  theme="twoTone"
                  style={{ fontSize: '20px' }}
                />
              </div>
            ) : (
              <div className={style.rowCheckbox} />
            )
          ) : (
            <InputNumber
              className={data[day].local ? style.rowInputLocal : style.rowInput}
              value={data[day] && data[day].timeSpent}
              onChange={(e) =>
                handleInputChange(e, data.stageId, data[day].date, data.area)
              }
              min={0}
              max={24}
              step={0.5}
            />
          )}
        </div>
      ))}
    </div>
  ) : (
    <div className={`${style.row} ${data.group === 'other' && style.other}`}>
      <div className={style.rowName}>{`${data.name} ${data.info || ''}`}</div>
      {daysArray.map((day) => (
        <div key={day} className={showHoliday(day, data, holidayDates)}>
          <div className={style.rowInfo}>{data[day].value}</div>
        </div>
      ))}
      {/*<div className={style.rowLastInfo}>{data.info}</div>*/}
    </div>
  );
};

export default Row;
